export const basketItem = ({initialQty = 1, productId = null, variantId = null, buttonText = 'Add to Cart'}) => {
    return {
        currentQty: initialQty,
        calculatedMax: null,
        inBasketQty: 0,
        productId,
        variantId,
        buttonText,

        get canAdd() {
            // return this.currentQty + this.inBasketQty <= this.calculatedMax;

            const qtyOk = this.currentQty + this.inBasketQty <= this.calculatedMax;

            // Get mixMatch instance related to THIS component/product only
            const mixMatchInstance = window.mixMatchComponents?.[this.productId];

            // If instance exists, require all colours selected, else skip check
            const coloursOk = !mixMatchInstance || mixMatchInstance.allColoursSelected();

            return qtyOk && coloursOk;
        },

        get remaining() {
            return Math.max(0, this.calculatedMax - this.inBasketQty - this.currentQty);
        },

        get displayText() {
            return this.currentQty > 1 ? `${this.buttonText} (${this.currentQty})` : this.buttonText;
        },

        get statusMessage() {
            if (this.remaining <= 0) {
                return 'Maximum in Cart';
            }

            return 'Exceeds Maximum';
        },

        init() {
            document.addEventListener(`qty-changed-${this.variantId}`, (e) => {
                const {qty, max, inBasketQty} = e.detail || {};

                this.currentQty = qty ?? 1;
                this.calculatedMax = max ?? 0;
                this.inBasketQty = inBasketQty ?? 0;
            });

            this.$watch('currentQty', (value) => {
                const parsed = parseInt(value) || 1;

                this.currentQty = Math.min(Math.max(1, parsed), this.calculatedMax ?? 999);
            });
        },
    };
};
